import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UserLayout from '../components/User/UserLayout';
import MatchList from '../components/Matches/MatchList';
import MyRegistrations from '../components/Matches/MyRegistrations';
import TeamManagement from '../components/Teams/TeamManagement';
import ResultsPage from '../components/Results/ResultsPage';
import WithdrawalRequest from '../components/Wallet/WithdrawalRequest';
import WalletPage from '../components/Wallet/WalletPage';
import ProfileSettings from '../components/User/ProfileSettings';

function UserRoutes({ session }) {
  return (
    <UserLayout session={session}>
      <Routes>
        {/* Default route */}
        <Route path="/" element={<Navigate to="/dashboard/matches" replace />} />

        {/* User pages */}
        <Route path="/matches" element={<MatchList session={session} />} />
        <Route path="/registrations" element={<MyRegistrations session={session} />} />
        <Route path="/teams" element={<TeamManagement session={session} />} />
        <Route path="/results" element={<ResultsPage session={session} />} />
        <Route path="/wallet" element={<WalletPage session={session} />} />
        <Route path="/withdrawal" element={<WithdrawalRequest session={session} />} />
        <Route path="/profile" element={<ProfileSettings session={session} />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard/matches" replace />} />
      </Routes>
    </UserLayout>
  );
}

export default UserRoutes;
